import { IController } from 'angular';
export class InstructionsCtrl implements IController {}
